import { render, staticRenderFns } from "./CardTouches.vue?vue&type=template&id=08689972&"
import script from "./CardTouches.vue?vue&type=script&lang=js&"
export * from "./CardTouches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports